console.log('js/reviews.js -> v0.1.0');

$(function() {
  if($('#reviews-wrapper').height() < 150){
    $('#reviews-wrapper').hide();
  };

  $("#button_confirm").on('click', function() {
    $("#review_form").submit();
  });
});

function getInstructorId(){
  var insId=0;

	var instructorName=$("#inpInstructor").val();
	insId = $("#inpInstructor").find('option:selected').prop("id");

  var $instructorReview = $("#instructorBlock_"+insId);
  if($instructorReview.length > 0){
    insId = -1;
  }

  return insId;
}

function instructorsReview(data){
  var id = getInstructorId();
  var instructorName = $("#inpInstructor").val();
  $("#inpInstructor").val("");

  if(id > 0){
    var $block = $("#instructorReviewBlock");
    var $clone = $block.clone().prop("id", "instructorBlock_"+id);
    $clone.prop("class", "instructor_block");
    $clone.appendTo("#instructorsContainer");

    $("#instructorBlock_"+id+" label[name=remove]").each(function(){
      $(this).prop("id", id);
    });

    $("#instructorBlock_"+id+" label[name=instructorName]").each(function(){
      $(this).text(instructorName);
      $(this).prop("id", "instructorName_"+id);
    });

    $("#instructorBlock_"+id+" input[name=review-instructor]").each(function(index){
      $(this).prop("name", "review_instructor_"+id);
      $(this).prop("id", "review_instructor_"+id);
    });

    $("#instructorBlock_"+id+" input[name=instructor]").each(function(index){
      $(this).prop("name", "instructor_"+id);
      $(this).prop("id", "r_"+id+"_"+index + 1);
    });

    $("#instructorBlock_"+id+" input[name=instructor]").each(function(index){
      $(this).prop("name", "instructor_"+id);
      $(this).prop("id", "r_"+id+"_"+index + 1);
    });

    $("#instructorBlock_"+id+" label[name=opText]").each(function(index){
      $(this).prop("for", "r_"+id+"_"+index + 1);
    });

  }

  $("#instructor-review-overlay").show(200);
  return false;
}

function closeInstructorReviews(data){
  $("#instructor-review-overlay").hide(200);

  return false;
}

function confirmSubmitReview(data){
	$("#customer-country").val($("#country-name").text());
  	loadReviewModalData();

  	$("#review-confirm-overlay").modal('show');
  	return false;
}

function loadReviewModalData(){
  var isAnonymous = parseInt($('input[name=isAnonymous]:checked').val()) + 1;
  $("#name-text").text($("#ri0"+isAnonymous+"-text").text());

  loadRadioOption("qualityOfActivity","#quality-activity-text");
  loadRadioOption("accommodationAndFacilities","#acc-facilities-text");
  loadRadioOption("food","#food-text");
  loadRadioOption("location","#location-text");
  loadRadioOption("valueForMoney", "#value-for-money-text");
  loadInstructorsSummary();

  $("#highlight-text").text($('#review-highlight').val());
  $("#what-good-text").text($('#review-text-pros').val());
  $("#what-not-good-text").text($('#review-text-cons').val());

  loadRadioOption("overallImpression", "#overall-text");
}

function loadRadioOption(radioId, textId){
  var id = $('input[name='+radioId+']:checked').prop("id");
  if(id != undefined){
    var selectedText = "#" + id + "-text";
    $(textId).text($(selectedText).text());
  }
}

function closeConfirmOverlay(){
  $("#review-confirm-overlay").modal('hide');
}

function loadInstructorsSummary(){
  $("#instructor-text").text("");

  $("#instructorsContainer div[class=instructor_block]").each(function(){
    var id = $(this).prop("id");
    id = id.replace("instructorBlock_", "");

    var name = $("#instructorName_"+id).text();
    var text = $("#review_instructor_"+id).val();

    $("#instructor-text").append("<br><strong>"+name+": </strong>"+text+"<br>");
  });
}

function removeInstructor(ins){
  $("#instructorBlock_"+ins.id).remove();

  if($("#instructorsContainer").children().length == 0){
    $("#instructor-review-overlay").hide(200);
  }
}
